import { RootState } from 'common/redux/core/root.reducer';

export const getPermissionEditStatus = (state: RootState) => state.user.roleEditStatus.status;

export const getPermissionListPagination = (state: RootState) => {
    return {
        currentPage: state.user.permissionList.currentPage,
        totalPages: state.user.permissionList.totalPages,
        totalCount: state.user.permissionList.totalCount,
        pageSize: state.user.permissionList.pageSize
    };
};

export const getUserListData = (state: RootState) => state.user.userList.data;

export const getRolesData = (state: RootState) => state.user.roleList.data;

export const getPermissionListData = (state: RootState) => state.user.permissionList.data;

export const getDataForDelete = (state: RootState) => state.user.dataForDelete;

export const getUserPermissionListStatus = (state: RootState) => state.user.permissionList.status;

export const getCreatePermissionStatus = (state: RootState) => state.user.roleAssignStatus.status;

export const getDeletePermissionStatus = (state: RootState) =>
    state.user.permissionDeleteStatus.status;

export const getPermissionEditData = (state: RootState) => state.user.permissionEditData;

export const getPermissionMessageStatus = (state: RootState) => state.user.messageStatus;

export const getParticipantsList = (state: RootState) => state.user.participantsList;

export const itemPerPage = (state: RootState) => state.user.userPerPage;

export const getAddUserModalVisibility = (state: RootState) => state.user.isAdminModalVisible;

export const getUserRoles = (state: RootState) => state.user.userRoles.data;
